module.exports = __webpack_public_path__ + "images/9e186d5b6d3ef120e6129135e828dffc.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/scenes/Shell/scenes/Header/img/logo.png
// module id = 1922
// module chunks = 0